// module.exports =
class FormValidator {
    checkUsername(username){
        return username.length >= 5 && username.indexOf(' ') === -1
            && !new RegExp("[-@#$%^&*(){}]").test(username);
    }

    checkId(id){
        return this.modulusThirteenCheck(id);
    }

    checkPassport(passport){
        return new RegExp("^[MADT][0-9]{8}$").test(passport);
    }

    //HELPER methods
    hasThirteenDigits(id){
        return new RegExp("^[0-9]{13}$").test(id);
    }

    modulusThirteenCheck(id){
        let isValid = false;
        if(this.hasThirteenDigits(id)){
            let total = 0;
            let evenConcatenated = "";
            let sumOfEvenConcatenated = 0;
            //A - Add all the digits in the odd positions (excluding last digit).
            for(let x = 0; x < id.length - 1; x += 2){
                total += parseInt(id.charAt(x));
            }
            //B - Move the even positions into a field and multiply the number by 2.
            for(let x = 1; x < id.length - 1; x += 2){
                evenConcatenated += id.charAt(x);
            }
            evenConcatenated = parseInt(evenConcatenated) * 2;
            //C - Add the digits of the result in B
            for(let x = 0; x < evenConcatenated.toString().length; x++){
                sumOfEvenConcatenated += parseInt(evenConcatenated.toString().charAt(x));
            }
            //D - Add the answer in A to the answer in C
            const resultOfSum = total + sumOfEvenConcatenated;
            //E - Subtract the second digit (i.e. 3) from 10. The number must tally with the last number in the ID Number.
            // If the result is 2 digits, the last digit is used to compare against the last number in the ID Number.
            // If the answer differs, the ID number is invalid.
            if(parseInt(id.charAt(id.length - 1)) === (10 - parseInt(resultOfSum.toString().charAt(resultOfSum.toString().length - 1)))){
                isValid = true;
            }
        }
        return isValid;
    }
}

export default FormValidator;